import React from 'react';
import Editor from '@monaco-editor/react';
import { RootState } from 'redux/store';
import { setCraApiVariable } from 'redux/actions/CraApiVariableActions';
import { useDispatch, useSelector } from 'react-redux';
import RoleHelper from 'RoleHelper';
import ComponentName from 'constant/ComponentName';

export default function BodyComponent({ name }: { name: string }) {
  const { craApiVariables } = useSelector((state: RootState) => state.craApiVariable);
  const dispatch = useDispatch();
  const currentVariable = craApiVariables[name];

  if (!currentVariable) {
    return null;
  }

  const onChangeEditorValue = (value: string) => {
    if (!RoleHelper.canEdit('EnrichmentApi')) return;
    const updated = { ...currentVariable, body: value };
    dispatch(setCraApiVariable(name, updated));
  };

  return (
    <div className={'flex flex-col w-full h-full mt-5'}>
      {
        <Editor
          options={{
            readOnly: !RoleHelper.canEdit('EnrichmentApi'),
          }}
          onMount={(editor) => {
            editor.updateOptions({ fontSize: 12, minimap: { enabled: false } });
          }}
          language={'json'}
          value={(currentVariable.body as string) || ''}
          onChange={(value) => onChangeEditorValue(value as string)}
          data-testid={`${ComponentName.API_VARIABLE}_body_editor`}
        />
      }
    </div>
  );
}
